import ActivityIndicator from "./activity-indicator";
import ArrowBottomLeft from "./arrow-bottom-left";
import ArrowBottomRight from "./arrow-bottom-right";
import ArrowDown from "./arrow-down";
import ArrowLeft from "./arrow-left";
import ArrowRight from "./arrow-right";
import ArrowTopLeft from "./arrow-top-left";
import ArrowTopRight from "./arrow-top-right";
import ArrowUp from "./arrow-up";
import AvailableSeats from "./available-seats";
import Backwards5s from "./backwards5";
import BathPlanner from "./bath-planner";
import BatteryEmpty from "./battery-empty";
import BatteryFull from "./battery-full";
import BatteryLow from "./battery-low";
import BatteryOk from "./battery-ok";
import Bluetooth from "./ble";
import BmsSmartHome from "./bms";
import BookmarkFilled from "./bookmark-active";
import BookmarkOutlined from "./bookmark";
import BrightnessMax from "./brightness-max";
import BrightnessMin from "./brightness-min";
import CategorySelect from "./relation";
import CellularNetwork from "./cellular-network";
import CheckmarkFilled from "./partial-match-check";
import ChevronDown from "./chevron-down";
import ChevronDownFlat from "./chevron-flat-down";
import ChevronLeftFlat from "./chevron-flat-left";
import ChevronRight from "./chevron-right";
import ChevronLeft from "./chevron-left";
import ChevronRightFlat from "./chevron-flat-right";
import ChevronUp from "./chevron-up";
import ChevronUpFlat from "./chevron-flat-up";
import ContentCopy from "./content-copy";
import ContentPaste from "./content-paste";
import CostPerPerson from "./cost-per-person";
import CreateGroup from "./create-group";
import CsvFile from "./csv";
import DislikeFilled from "./thumbs-down";
import DislikeOutlined from "./thumbs-down-active";
import DoubleChevronDown from "./double-chevron-down";
import DoubleChevronDownFlat from "./double-chevron-flat-down";
import DoubleChevronLeft from "./double-chevron-left";
import DoubleChevronLeftFlat from "./double-chevron-flat-left";
import DoubleChevronRight from "./double-chevron-right";
import DoubleChevronRightFlat from "./double-chevron-flat-right";
import DoubleChevronUp from "./double-chevron-up";
import DoubleChevronUpFlat from "./double-chevron-flat-up";
import DragHandler from "./drag-drop";
import DuofreshSticks from "./duofresh-sticks";
import EmptyPipe from "./empty-pipe";
import ExitFullscreen from "./exit-fullscreen";
import EyeHide from "./eye-hide";
import FailedConnection from "./failed-connection";
import FanMax from "./fan-max";
import FanMin from "./fan-min";
import FavouriteFilled from "./favourite-active";
import FavouriteOutlined from "./favourite";
import FlushMax from "./flush-max";
import FlushMin from "./flush-min";
import FlushOff from "./flush-off";
import Forwards5s from "./forwards-5";
import GalleryView from "./gallery-view";
import GeberitId from "./geberit-id";
import GeBus from "./gbus";
import GroupAction from "./group-action";
import Images from "./product-images";
import Individual from "./individual";
import Link from "./link";
import ListView from "./list-view";
import LogFile from "./log";
import LogOut from "./log-out";
import MobileDevice from "./mobile-device";
import MoreLarge from "./more";
import MoreSmall from "./more-small";
import MoveFolder from "./move-to-folder";
import MP3 from "./audio";
import NewFile from "./add-to-list";
import OpenCamera from "./open-camera";
import Plus from "./plus";
import Print from "./printer";
import RemoteMaintenance from "./remote-maintenance";
import ReturnGoods from "./return-goods";
import Ruler from "./technical-drawing";
import SampleCatalogue from "./sample-catalogue";
import SanitaryFlush from "./sanitary-flush";
import Save from "./disk";
import SelectOff from "./select-off";
import SelectOn from "./select-on";
import SensorMax from "./sensor-max";
import SensorMin from "./sensor-min";
import SortAscending from "./chevron-down-filled";
import SortDescending from "./chevron-up-filled";
import TemperatureDown from "./temperature-down";
import TemperatureUp from "./temperature-up";
import ThumbsUp from "./Thumbs-up";
import ThumbsUpActive from "./thumb-up-active";
import ToiletControlRectangle from "./actuator-rectangular";
import ToiletControlRound from "./toilet-control";
import Touch from "./inspiraton";
import TruncationPagination from "./more-pagination";
import UnknownProduct from "./unknown-product";
import UserLoggedOff from "./user-logged-off";
import UserLoggedOn from "./user-logged-on";
import View3d from "./viewer";
import ViewDocument from "./service-directory";
import VolumeLouder from "./volume-louder";
import VolumeMute from "./volume-mute";
import VolumeQuieter from "./volume-quieter";
import WarningInfo from "./info";
import WarningModerate from "./warning-moderate";
import WarningSevere from "./warning-severe";
import WebApplication from "./web-application";
import X from "./x";
import XLS from "./excel";
import ZoomIn from "./zoom-in";
import ZoomOut from "./zoom-out";
export const changedIcons = {
    activityindicator: ActivityIndicator,
    actuatorrectangular: ToiletControlRectangle,
    addtolist: NewFile,
    anchor: Link,
    arrowbottomleft: ArrowBottomLeft,
    arrowbottomright: ArrowBottomRight,
    arrowdown: ArrowDown,
    arrowleft: ArrowLeft,
    arrowright: ArrowRight,
    arrowtopleft: ArrowTopLeft,
    arrowtopright: ArrowTopRight,
    arrowup: ArrowUp,
    audio: MP3,
    availableseats: AvailableSeats,
    backwards5: Backwards5s,
    bathplanner: BathPlanner,
    batteryempty: BatteryEmpty,
    batteryfull: BatteryFull,
    batterylow: BatteryLow,
    batteryok: BatteryOk,
    ble: Bluetooth,
    bms: BmsSmartHome,
    bookmark: BookmarkOutlined,
    bookmarkactive: BookmarkFilled,
    brightnessmax: BrightnessMax,
    brightnessmin: BrightnessMin,
    cellularnetwork: CellularNetwork,
    chevrondown: ChevronDown,
    chevrondownfilled: SortAscending,
    chevronflatdown: ChevronDownFlat,
    chevronflatleft: ChevronLeftFlat,
    chevronflatright: ChevronRightFlat,
    chevronflatup: ChevronUpFlat,
    chevronright: ChevronRight,
    chevronleft: ChevronLeft,
    chevronup: ChevronUp,
    chevronupfilled: SortDescending,
    contentcopy: ContentCopy,
    contentpaste: ContentPaste,
    costperperson: CostPerPerson,
    creategroupe: CreateGroup,
    csv: CsvFile,
    disk: Save,
    doublechevrondown: DoubleChevronDown,
    doublechevronflatdown: DoubleChevronDownFlat,
    doublechevronflatleft: DoubleChevronLeftFlat,
    doublechevronflatright: DoubleChevronRightFlat,
    doublechevronflatup: DoubleChevronUpFlat,
    doublechevronleft: DoubleChevronLeft,
    doublechevronright: DoubleChevronRight,
    doublechevronup: DoubleChevronUp,
    dragdrop: DragHandler,
    duofreshsticks: DuofreshSticks,
    emptypipe: EmptyPipe,
    excel: XLS,
    exitfullscreen: ExitFullscreen,
    eyehide: EyeHide,
    failedconnection: FailedConnection,
    fanmax: FanMax,
    fanmin: FanMin,
    favourite: FavouriteOutlined,
    favouriteactive: FavouriteFilled,
    flushmax: FlushMax,
    flushmin: FlushMin,
    flushoff: FlushOff,
    forwards5: Forwards5s,
    galleryview: GalleryView,
    gbus: GeBus,
    geberitid: GeberitId,
    groupaction: GroupAction,
    individual: Individual,
    info: WarningInfo,
    inspiraton: Touch,
    link: Link,
    listview: ListView,
    log: LogFile,
    logout: LogOut,
    mobiledevice: MobileDevice,
    more: MoreLarge,
    morepagination: TruncationPagination,
    moresmall: MoreSmall,
    movetofolder: MoveFolder,
    opencamera: OpenCamera,
    partialmatchcheck: CheckmarkFilled,
    plus: Plus,
    printer: Print,
    productimages: Images,
    relation: CategorySelect,
    remotemaintenance: RemoteMaintenance,
    returngoods: ReturnGoods,
    samplecatalogue: SampleCatalogue,
    sanitaryflush: SanitaryFlush,
    selectoff: SelectOff,
    selecton: SelectOn,
    sensormax: SensorMax,
    sensormin: SensorMin,
    servicedirectory: ViewDocument,
    technicaldrawing: Ruler,
    temperaturedown: TemperatureDown,
    temperatureup: TemperatureUp,
    thumbsdown: DislikeOutlined,
    thumbsdownactive: DislikeFilled,
    thumbsup: ThumbsUp,
    thumbsupactive: ThumbsUpActive,
    toiletcontrol: ToiletControlRound,
    twitter: X,
    unknownproduct: UnknownProduct,
    userloggedoff: UserLoggedOff,
    userloggedon: UserLoggedOn,
    viewer: View3d,
    volumelouder: VolumeLouder,
    volumemute: VolumeMute,
    volumequieter: VolumeQuieter,
    warningmoderate: WarningModerate,
    warningsevere: WarningSevere,
    webapplication: WebApplication,
    zoomin: ZoomIn,
    zoomout: ZoomOut,
};
